@for (field of productCardParameterFields; track $index) {
  <div class="parameter-field-wrapper">
    <mat-form-field
      appearance="outline"
      class="none-pointer-events"
      [matTooltip]="getValue(field.fieldName)"
    >
      <mat-label>{{ field.label }}</mat-label>
      <input
        matInput
        [value]="getValue(field.fieldName)"
      >
    </mat-form-field>
    <button
      mat-icon-button
      type="button"
      class="parameter-btn"
      [disabled]="!productCardData().id"
      (click)="handleOpenModal(field.fieldName)"
    >
      <mat-icon>sync</mat-icon>
    </button>
  </div>

}
